<template>
  <div class="course-report-wrapper">
    <el-button @click="back" class="back" type="primary" plain>返回</el-button>
    <el-row>
      <el-col :span="4">
        <el-menu
          class="course-menu"
          :default-active="currentLabel"
          @select="handleSelect">
          <template v-for="(course, key) in courseList">
            <el-submenu v-if="course.subset.length > 0" :key="key + 1" :index="course.value">
              <template slot="title">
                <i class="iconfont" :class="courseIcon(course.label)"></i>
                <span>{{course.label}}</span>
              </template>
              <el-menu-item
                v-for="(subset, key1) in course.subset"
                :key="key1"
                :index="subset.value">
                {{subset.label}}
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-if="!course.subset.length"
              :key="`${key}a`"
              :index="course.value">
              <i class="iconfont" :class="courseIcon(course.label)" ></i>
              {{course.label}}
            </el-menu-item>
          </template>
        </el-menu>
      </el-col>
      <el-col class="report-wrapper" :span="20">
        <div class="bdc-report"
          v-if="currentLabel === 'vocabulary' || currentLabel === 'ENGLISH_GXYD'">
          <div class="breadcrumb">
            {{ currentLabel === 'vocabulary' ? '单词' : '高效阅读' }}学习报告
          </div>
          <p class="tip-line">汇总了您近期的单词学习的单词量、学习时间、测试成绩等。</p>
          <van-BDC-report :code="currentLabel" />
        </div>
        <div class="no-course" v-else-if="!courseList.length">暂无课程</div>
        <div class="no-report" v-else>
          <img src="https://img1.wxzxzj.com/vuedcc7e0da3bc7446abfb3831881aad2f07.png" alt="">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import api from '@/api/graphql/statistic';
import {
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Row,
  Col,
  Button,
} from 'element-ui';
import BDCReport from '@/components/quizzes/bdc/Report';
import utils from '@/services/utils';
export default {
  components: {
    ElMenu: Menu,
    ElMenuItem: MenuItem,
    ElMenuItemGroup: MenuItemGroup,
    ElSubmenu: Submenu,
    ElRow: Row,
    ElCol: Col,
    ElButton: Button,
    VanBDCReport: BDCReport,
  },
  data() {
    return {
      courseList: [],
      currentLabel: '',
    };
  },
  created() {
    api.getCourseReportLabelList()
      .then(({ CourseReportLabelList }) => {
        const { courseType } = utils.storage('bookInfo') || {};
        this.courseList = (
          CourseReportLabelList
            .map((subject) => {
              subject.subset = subject.subset.filter(item => item.status === 1);
              return subject;
            })
            .filter((subject) => subject.subset.length)
        );
        let course = null;
        if (this.courseList.length) {
          for (let i = 0; i < this.courseList.length; i++) {
            if (this.courseList[i].subset.length) {
              course = utils.Array.find(this.courseList[i].subset, { value: courseType }, 'value');
            } else {
              if (this.courseList[i].value === courseType) {
                course = this.courseList[i];
              }
            }
            if (course) {
              this.currentLabel = course.value;
            }
          }
          if (!this.currentLabel) {
            if (this.courseList[0].subset.length) {
              this.currentLabel = this.courseList[0].subset[0].value;
            } else {
              this.currentLabel = this.courseList[0].value;
            }
          }
        }
      });
  },
  methods: {
    courseIcon(course) {
      if (/会考/.test(course)) {
        return 'icon-test';
      }
      if (/历史/.test(course)) {
        return 'icon-history';
      }
      if (/生物/.test(course)) {
        return 'icon-biology';
      }
      if (/地理/.test(course)) {
        return 'icon-geography';
      }
      if (/英语/.test(course)) {
        return 'icon-english';
      }
      if (/语文/.test(course)) {
        return 'icon-han';
      }
      if (/化学/.test(course)) {
        return 'icon-chemistry';
      }
      if (/过期/.test(course)) {
        return 'icon-calendar-remove';
      }
      return 'icon-class';
    },
    back() {
      this.$router.go(-1);
    },
    handleSelect(label) {
      this.currentLabel = label;
      if (this.currentLabel !== 'vocabulary'
        && this.currentLabel !== 'ENGLISH_GXYD') {
        utils.message('本功能上线中，敬请期待！');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';
  .course-report-wrapper {
    height: 100%;
    min-height: 661px;
    .back {
      position: absolute;
      top: 10px;
      right: 0;
      z-index: 999;
    }
    .el-row {
      height: 100%;
      .el-col {
        height: 100%;
        .course-menu {
          height: 100%;
          overflow-y: auto;
          .iconfont {
            margin-right: 5px;
            font-size: 24px;
          }
        }
      }
      .report-wrapper {
        padding: 20px 20px 0;
        height: 100%;
        .bdc-report {
          height: 100%;
        }
        .no-course {
          position: relative;
          top: 50%;
          text-align: center;
          font-size: 26px;
        }
        .no-report {
          width: 100%;
          height: 100%;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
</style>
